import { ArrowUpRightIcon } from '@phosphor-icons/react'
import Link from 'next/link'
import { FahrlehrerCh } from '@/src/@types/blinkadmin'
import Button from '@/src/components/core/Button'
import Container from '@/src/components/layout/Container'

const MoreLocations = ({
  nearbyLocations,
  selectedLocation,
}: FahrlehrerCh.TeacherProfile & {
  selectedLocation: FahrlehrerCh.TeacherProfileLocation
}) => {
  const group = nearbyLocations.find(
    (g) => g.sourceLocationId === selectedLocation.id
  )

  if (!group || group.nearby.length === 0) return null

  return (
    <section className="bg-linear-to-b from-gray-50 to-gray-100 py-16">
      <Container>
        <div className="space-y-6">
          <h2 className="text-4xl font-black md:text-10xl">
            Weitere Standorte in der Region {selectedLocation.name}
          </h2>
          <p className="mt-4 text-gray-600 md:text-lg">
            Fahrschulangebote findest du auch an folgenden Standorten
          </p>
          <div className="flex flex-col gap-3 md:flex-row md:flex-wrap">
            {group.nearby.map((location) => (
              <Button
                key={location.id}
                as={Link}
                // TODO: adapt based on user context/query param
                href={location.urls.index}
                version="gray-outlined"
                icon={<ArrowUpRightIcon weight="bold" />}
                iconPosition="right"
              >
                Fahrlehrer:innen {location.name}
              </Button>
            ))}
          </div>
        </div>
      </Container>
    </section>
  )
}

export default MoreLocations
